import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { act } from "react";
import { Button, Col, Modal, Row, Table } from "react-bootstrap";
import NumberFormat from "react-number-format";
import { BranchFilterComponentAGMemo } from "./BranchFilterComponentAGMemo";
import { BarChart, Bar, ResponsiveContainer, XAxis, YAxis } from "recharts";

const websiteDataAll = require("./website-location-count.json");
const websiteData =
  websiteDataAll?.pageProps?.iniVehicleFilterOptions?.filters?.dealership || [];

console.log("websiteData", websiteData);

const AutogateOnlineReportVICStockManagement = ({ onlineData }) => {
  const [show, setShow] = useState(false);
  const [websiteCount, setWebsiteCount] = useState({});
  const [filteredData, setFilteredData] = useState([]);
  const [branchFilter, setBranchFilter] = useState("");
  const [chartDataAll, setChartDataAll] = useState([]);

  // const [websiteData, setWebsiteData] = useState([]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // const getWebsiteCountByAgName = (sa) => {
  //   console.log("sa", sa[0]);
  //   const agSiteId = sa[0]?.Seller?.Identifier;
  //   console.log("agSiteId", agSiteId);
  //   const agMapped = ag_to_eclipse_mapping.find((m) => {
  //     return m?.guid === agSiteId;
  //   });
  //   console.log("agMapped", agMapped);
  //   if (!agMapped) {
  //     return "";
  //   }

  //   let agName = agMapped?.autogate_name;
  //   if (agSiteId === "844e6591-dc47-533f-215d-702efa124fb9") {
  //     agName = "Dutton One Westgate";
  //   }
  //   console.log("agName", agName);

  //   try {
  //     const foundData = websiteData.find((w) => {
  //       console.log("w", w?.data?.name);
  //       return w?.data?.name.trim() === agName.trim();
  //     });
  //     if (agName === "Dutton One Westgate") {
  //       // Add Imports count
  //       const importsCount = websiteData.find((w) => {
  //         return w?.data?.name === "Dutton One Japanese Import Vehicles";
  //       });
  //       console.log("importsCount", importsCount);
  //       return foundData?.vCount + importsCount?.vCount;
  //     }
  //     console.log("foundData", foundData);
  //     return foundData?.vCount || 0;
  //   } catch (e) {
  //     console.log("error", e);
  //     return "";
  //   }
  // };

  const handleBranchFilterTa = (branches) => {
    console.log("branches", branches);
    if (!branches || branches.length === 0) {
      setBranchFilter("");
      setFilteredData(onlineData);
      return;
    }
    setBranchFilter(branches);
  };

  useEffect(() => {
    if (branchFilter) {
      console.log("branchFilter", branchFilter);
      const filtered = onlineData.filter((veh) => {
        const agSiteId = veh?.Seller?.Identifier;
        return agSiteId === branchFilter;
      });
      setFilteredData(filtered);
    } else {
      setFilteredData(onlineData);
    }
  }, [branchFilter, onlineData]);

  useEffect(() => {
    //  Chart group by AGE count by ACTION
    const chartData = filteredData.reduce((acc, veh) => {
      const age = dayjs().diff(veh.CreatedUtc, "day");
      let action = "";
      if (age < 30) {
        action = "<30";
      } else if (age >= 30 && age < 45) {
        action = "30-45";
      } else if (age >= 45 && age < 60) {
        action = "45-60";
      } else if (age >= 60) {
        action = "60+";
      }

      if (!acc[action]) {
        acc[action] = { name: action, vCount: 0 };
      }
      acc[action].vCount += 1;
      return acc;
    }, {});
    const chartDataArray = Object.values(chartData);
    // console.log("chartDataArray", chartDataArray);
    setChartDataAll(chartDataArray);
  }, [filteredData]);

  return (
    <>
      <Row className="mb-3">
        <Col xs={12} md={6}>
          <Button variant="outline-success" onClick={handleShow}>
            Autogate Online Report VIC{" "}
          </Button>
        </Col>
      </Row>

      <Modal
        show={show}
        onHide={handleClose}
        size="xl"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Autogate Online Report VIC</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="mb-3">
            <Col xs={12} md={6}>
              <BranchFilterComponentAGMemo
                handleBranchFilterTaHOC={handleBranchFilterTa}
              />
            </Col>
            <Col xs={12} md={6}>
              <ResponsiveContainer width="100%" height={300}>
                <BarChart
                  style={{ width: "100%", height: "300px" }}
                  data={chartDataAll}
                  margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                >
                  <XAxis
                    dataKey="name"
                    angle={-30}
                    textAnchor="end"
                    interval={0}
                    height={50}
                  />
                  <YAxis
                    label={{
                      value: "Vehicles",
                      angle: -90,
                      postion: "top",
                    }}
                  />
                  <Bar dataKey="vCount" fill="#8884d8" />
                </BarChart>
              </ResponsiveContainer>
            </Col>
          </Row>

          <Table striped bordered hover>
            <thead>
              <tr>
                <td>##</td>
                <td>Yard</td>
                <td>VIN</td>
                <td>Description</td>
                <td>Asking Price</td>
                <td>Online Age</td>
                <td>Action</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan={7}>
                  <strong>Online Vehicles: {filteredData?.length}</strong>
                </td>
              </tr>
              {filteredData?.map((veh, idx) => {
                const age = dayjs().diff(veh.CreatedUtc, "day");
                let action = "";
                let actionColour = "";
                if (age < 30) {
                  action = "Good age";
                  actionColour = "green";
                } else if (age >= 30 && age < 45) {
                  action = "Old Stock, Last Chance";
                  actionColour = "orange";
                } else if (age >= 45 && age < 60) {
                  action = "Urgent Sell Now";
                  actionColour = "red";
                } else if (age >= 60) {
                  action = "Urgent Relocation";
                  actionColour = "purple";
                }

                return (
                  <tr key={idx}>
                    <td>
                      <img width={100} src={veh?.Thumbnail} />
                    </td>
                    <td>{veh?.Site}</td>
                    <td>
                      {
                        veh?.Identification?.find((i) => i.Type === "VIN")
                          ?.Value
                      }
                    </td>
                    <td>{`${veh?.Title}`}</td>
                    <td>
                      <NumberFormat
                        value={veh.Price}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"$"}
                      />
                    </td>
                    <td>{dayjs().diff(veh.CreatedUtc, "day")}</td>
                    <td
                      style={{
                        color: actionColour,
                        fontWeight: "bold",
                      }}
                    >
                      {action}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          {/* <pre>{JSON.stringify(onlineData[0], null, 2)}</pre> */}
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AutogateOnlineReportVICStockManagement;
